import {Link} from 'react-router-dom'
import {PATH_CONTACTS} from '../../../../../app/routing/paths'
import {Tooltip, Whisper} from 'rsuite'
import {KTSVG} from '../../../../helpers'
import React, {FC} from 'react'
import {Contact} from '../../../../../app/@types'
import {FormatDateToCA} from '../../../../../app/features'

type Props = {
    data: Contact[]
    selectedItems: number[]
    handleCheckboxChange: (id: number) => void
    handleRemove: (id: number) => void
}

const Row: FC<Props> = ({data, selectedItems, handleCheckboxChange, handleRemove}) => {

    return (
        <>
            {
                data.map((item, index) => (
                    <tr key={index}>
                        <td>
                            <div className="form-check form-check-sm form-check-custom form-check-solid">
                                <input className="form-check-input"
                                       type="checkbox"
                                       value={item.id}
                                       checked={selectedItems.includes(item.id)}
                                       onChange={() => handleCheckboxChange(item.id)}
                                />
                            </div>
                        </td>
                        <td>{FormatDateToCA(item.created_at)}</td>
                        <td><Link className="text-gray-800 fs-6 fw-bolder text-hover-primary"
                                  to={`${PATH_CONTACTS.contactEdit}/${item.id}`}
                        >{item.email}</Link></td>
                        <td><span className="text-gray-800 fs-6 fw-bolder">{item.first_name}</span></td>
                        <td><span className="text-gray-800 fs-6 fw-bolder">{item.last_name}</span></td>
                        <td><span className="text-gray-800 fs-6 fw-bolder">{item.number}</span></td>
                        <td className="text-end">
                            <Whisper placement="top" controlId="control-id-click" trigger="hover"
                                     speaker={(<Tooltip>Modifier</Tooltip>)}
                            >
                                <Link className="btn btn-sm btn-icon btn-active-light-primary me-1"
                                      to={`${PATH_CONTACTS.contactEdit}/${item.id}`}
                                >
                                    <KTSVG path="/media/icons/duotune/art/art005.svg"
                                           className="svg-icon-3 svg-icon-primary" />
                                </Link>
                            </Whisper>
                            <Whisper placement="top" controlId="control-id-click" trigger="hover"
                                     speaker={(<Tooltip>Supprimer</Tooltip>)}
                            >
                                <button className="btn btn-sm btn-icon btn-active-light-danger"
                                        onClick={() => handleRemove(item.id)}
                                >
                                    <KTSVG path="/media/icons/duotune/general/gen027.svg"
                                           className="svg-icon-3 svg-icon-danger" />
                                </button>
                            </Whisper>
                        </td>
                    </tr>
                ))
            }
        </>
    )
}

export {Row}